"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const highlightCardInputs = [
  {
    name: "imageUrl",
    friendlyName: "Background image",
    type: "file",
    allowedFileTypes: IMAGE_FILE_TYPES,
    required: true,
    defaultValue:
      "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F035813b7aeb845139d31942675bcbb18",
  },
  {
    name: "buttonText",
    type: "string",
    required: true,
    defaultValue: "Learn more",
  },
  {
    name: "description",
    type: "string",
    required: true,
    defaultValue:
      "Nunc varius nisl felis. Donec fermentum, lorem at scelerisque",
  },
  {
    name: "title",
    type: "string",
    defaultValue: "Highlight title",
    required: true,
  },
  {
    name: "linkUrl",
    type: "string",
    required: true,
    defaultValue: "/",
  },
  {
    name: "theme",
    type: "string",
    enum: ["light", "dark"],
    defaultValue: "dark",
    required: true,
  },
  {
    name: "leftBadgeText",
    type: "string",
    defaultValue: "New",
  },
  {
    name: "rightBadgeText",
    type: "string",
    defaultValue: "10%",
  },
] as const satisfies Inputs;

export const HighlightCardComponent: RegisteredComponent = {
  name: "HighlightCard",
  component: dynamic(async () =>
    withValidation(
      highlightCardInputs,
      (await import("./HighlightCard")).HighlightCard,
      "HighlightCard"
    )
  ),
  inputs: highlightCardInputs,
};
